import Cancel from '../../../../media/cancel_2.png';
import Add from '../../../../media/add.png';
import Remove from '../../../../media/delete.png';
import Correct from '../../../../media/correct.png';

function EditExamManager({ exam, onChange, errors, disabled, hideReset }) {

  const resetExam = () => {
    onChange({
       ...exam,
        min_score_to_pass: '',
        num_questions: '',
        time_limit_minutes: '',
        questions: [],
    });
  };

  
 
  const handleExamChange = (field, value) => {
    const updated = { ...exam, [field]: value };
    onChange(updated);
  };

  const handleQuestionChange = (qIndex, field, value) => {
    const updatedQuestions = [...exam.questions];
    const question = updatedQuestions[qIndex];

    if (question[field] !== value) {
      question[field] = value;

      question.modified =
        question.question_text !== question.original_question_text ||
        question.type !== question.original_type;
    }

    if (field === "type" && value === "truefalse") {
      question.choices = [
        { id: crypto.randomUUID(), choice_text: "Vero", correct: false },
        { id: crypto.randomUUID(), choice_text: "Falso", correct: false },
      ];
    }

    onChange({ ...exam, questions: updatedQuestions });
  };

  
  const handleChoiceChange = (qIndex, choiceId, field, value) => {
    const updatedQuestions = [...exam.questions];

    const choices = updatedQuestions[qIndex].choices;

    
    if (field === "correct" && value === true) {
      choices.forEach(c => {
        const prev = c.correct;

        
        c.correct = c.id === choiceId;

      
        if (prev !== c.correct) {
          c.modified =
            c.choice_text !== c.original_choice_text ||
            c.correct !== c.original_correct;
        }
      });

    } else {
    
      const choice = choices.find(c => c.id === choiceId);

      if (choice && choice[field] !== value) {
        choice[field] = value;

        choice.modified =
          choice.choice_text !== choice.original_choice_text ||
          choice.correct !== choice.original_correct;
      }
    }

    onChange({ ...exam, questions: updatedQuestions });
  };

  const addQuestion = () => {
    const newQuestion = {
      id: crypto.randomUUID(),
      question_text: "",
      type: "multiple",
      choices: [
        { id: crypto.randomUUID(), choice_text: "", correct: false },
        { id: crypto.randomUUID(), choice_text: "", correct: false },
      ],
    };
    const updated = { ...exam, questions: [...exam.questions, newQuestion] };
    onChange(updated);
  };

  
  const removeQuestion = qIndex => {
    const updated = { ...exam, questions: exam.questions.filter((_, i) => i !== qIndex) };
    onChange(updated);
  };

 
  const addChoice = qIndex => {
    const updatedQuestions = [...exam.questions];
    updatedQuestions[qIndex].choices.push({ id: crypto.randomUUID(), choice_text: "", correct: false });
    const updated = { ...exam, questions: updatedQuestions };
    onChange(updated);
  };

 
  const removeChoice = (qIndex, choiceId) => {
    const updatedQuestions = [...exam.questions];
    const choices = updatedQuestions[qIndex].choices;
    if (choices.length <= 2) return; // non rimuovere se rimangono meno di 2
    updatedQuestions[qIndex].choices = choices.filter(c => c.id !== choiceId);
    const updated = { ...exam, questions: updatedQuestions };
    onChange(updated);
  };

  return (
    <>
        <h3>Esame del Modulo</h3>
        {!hideReset && (
          <button
          type="button"
          onClick={resetExam}
          disabled={disabled}
          style={{
              backgroundColor: "crimson",
              color: "white",
              marginTop: "15px"
          }}
          >
          Reset esame
          </button>
        )}
        <div className="form-groupz">
        <label>Punteggio minimo per passare</label>
        <input
            type="number"
            value={exam.min_score_to_pass}
            onChange={(e) => handleExamChange("min_score_to_pass", e.target.value)}
            onWheel={(e) => e.currentTarget.blur()}
            placeholder="Punteggio minimo"
            disabled={disabled}
        />
        {errors.exam_min_score_to_pass && <small>{errors.exam_min_score_to_pass}</small>}
        </div>

        <div className="form-groupz">
        <label>Numero di domande</label>
        <input
            type="number"
            value={exam.num_questions}
            onChange={(e) => handleExamChange("num_questions", e.target.value)}
            onWheel={(e) => e.currentTarget.blur()}
            placeholder="Numero di domande"
            disabled={disabled}
        />
        {errors.num_questions && <small>{errors.num_questions}</small>}
        </div>

        <div className="form-groupz">
        <label>Tempo limite (minuti)</label>
        <input
            type="number"
            value={exam.time_limit_minutes}
            onChange={(e) => handleExamChange("time_limit_minutes", e.target.value)}
            onWheel={(e) => e.currentTarget.blur()}
            placeholder="Tempo limite opzionale"
            disabled={disabled}
        />
        {errors.time_limit_minutes && <small>{errors.time_limit_minutes}</small>}
        </div>

        <label style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <input
          type="checkbox"
          checked={exam.shuffle_questions}
          onChange={e =>
            onChange({
              ...exam,
              shuffle_questions: e.target.checked
            })
          }
          disabled={disabled}
        />
        Randomizza domande
      </label>

      <label style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <input
          type="checkbox"
          checked={exam.shuffle_choices}
          onChange={e =>
            onChange({
              ...exam,
              shuffle_choices: e.target.checked
            })
          }
          disabled={disabled}
        />
        Randomizza risposte
      </label>

        {exam.questions.map((q, qIndex) => (
        <div key={q.id} className="lesson-card" style={{marginTop: "40px"}}>
           <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
             <button
                type="button"
                onClick={() => removeQuestion(qIndex)}
                style={{ marginTop: "0.5rem" }}
                disabled={disabled}
                >
                <img src={Remove}  alt="cancel" style={{ width: 16, height: 16}} />
            </button>
            </div>
            {errors[`correct_${qIndex}`] && (
                <span className="error2">
                  {errors[`correct_${qIndex}`][0]}
                </span>
              )}
            <label>Domanda #{qIndex + 1}</label>

            <input
            type="text"
            value={q.question_text}
            onChange={(e) =>
                handleQuestionChange(qIndex, "question_text", e.target.value)
            }
            placeholder="Testo della domanda"
            disabled={disabled}
            className={`input ${errors[`question_text_${qIndex}`] ? "error" : ""}`}
            />

           {errors[`question_text_${qIndex}`] && (
            <span className="error">{errors[`question_text_${qIndex}`]}</span>
            )}

            <label>Tipo di domanda</label>
            <select
            value={q.type}
            onChange={(e) =>
                handleQuestionChange(qIndex, "type", e.target.value)
            }
            disabled={disabled}
            >
            <option value="multiple">Scelta multipla</option>
            <option value="truefalse">Vero/Falso</option>
            </select>

            {q.choices.map((c, ci) => (
            <div>
            <div
                key={c.id}
                style={{
                display: "flex",
                alignItems: "center",
                marginTop: "0.5rem",
                marginBottom: '-10px'
                }}
            >
                <input
                type="text"
                value={c.choice_text}
                onChange={(e) =>
                    handleChoiceChange(qIndex, c.id, "choice_text", e.target.value)
                }
                placeholder="Scelta"
                style={{ flex: 1, marginRight: "0.5rem" , marginBottom: "20px" }}
                disabled={disabled || q.type === "truefalse"}
                className={`input ${errors[`choice_${qIndex}_${ci}`] ? "error" : ""}`}
                />

                <label style={{  display: 'flex', alignItems: 'center', gap: '10px', marginTop: "-10px" }}>
                <img src={Correct}  alt="cancel" style={{ width: 32, height: 32}} />
                <input
                    type="checkbox"
                    checked={c.correct}
                    onChange={(e) =>
                    handleChoiceChange(qIndex, c.id, "correct", e.target.checked)
                    }
                    disabled={disabled}
                />
                </label>

                {q.type === "multiple" && (
                <button
                    type="button"
                    onClick={() => removeChoice(qIndex, c.id)}
                    disabled={disabled || q.choices.length <= 2}
                    style={{ marginLeft: "30px", marginTop: "-20px"}}
                >
                    <img src={Cancel}  alt="cancel" style={{ width: 16, height: 16}} />
                </button>
                )}
            </div>
            {errors[`choice_${qIndex}_${ci}`] && (
                <span className='error'>
                  {errors[`choice_${qIndex}_${ci}`][0]}
                </span>
              )}
            </div>
            ))}


            {q.type === "multiple" && (
            <button
                type="button"
                onClick={() => addChoice(qIndex)}
                disabled={disabled}
            >
               <img src={Add}  alt="cancel" style={{ width: 16, height: 16}} />
            </button>
            )}
        </div>
        ))}

        <button type="button" onClick={addQuestion} disabled={disabled}>
        Aggiungi domanda
        </button>

        <hr />
    </>
    );
}

export default EditExamManager;